import { render, staticRenderFns } from "./FiltroDocumento.vue?vue&type=template&id=68938fe8"
import script from "./FiltroDocumento.vue?vue&type=script&lang=js"
export * from "./FiltroDocumento.vue?vue&type=script&lang=js"
import style0 from "./FiltroDocumento.vue?vue&type=style&index=0&id=68938fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports